import {useContactCardInput} from '../context/ContactSellerV2Context.js'
import {CONTACT_ACTION_IDS, defaultAvailableActions} from '../contracts.js'
import PhoneAction from './PhoneAction.js'
import WhatsappButton from './WhatsappButton.js'

export const BASE_CLASS = 'mt-ContactCardV2-actions'

const ACTIONS = [
  {id: CONTACT_ACTION_IDS.PHONE, Component: PhoneAction},
  {id: CONTACT_ACTION_IDS.WHATSAPP, Component: WhatsappButton}
]

const ContactActions = () => {
  const {availableActions = defaultAvailableActions} = useContactCardInput()

  const actions = ACTIONS.map(({id, Component}) => {
    const action = availableActions[id] || {}

    if (!action.available || !Component) {
      return null
    }

    return <Component key={id} iconOnlyCapable={false} />
  }).filter(Boolean)

  if (actions.length === 0) {
    return null
  }

  return <div className={BASE_CLASS}>{actions}</div>
}

ContactActions.displayName = 'ContactActions'

ContactActions.propTypes = {}

export default ContactActions
